import { parseDate, parseToDate } from "@/lib/utils";

export const fetchServerTime = async (
  setServerTime: (serverTime: string | null) => void
) => {
  try {
    const startTime = performance.now();

    const data = await fetch(`${window.location.origin}/api/server-time`, {
      headers: { "X-Requested-With": "fetch" },
    });

    const response = await data.json();
    const serverTime = response?.serverTime || null;

    const endTime = performance.now();
    const requestDurationMs = endTime - startTime;

    if (serverTime) {
      const serverTimeMs = parseDate(serverTime);

      const durationSeconds = Math.ceil(requestDurationMs);

      const serverDate = parseToDate(serverTimeMs + durationSeconds);
      const correctedTime = serverDate.toISOString().replace("Z", "+00:00");

      setServerTime(correctedTime);
    } else {
      setServerTime(null);
    }
  } catch (error) {
    setServerTime(null);
  }
};
